module.exports = __webpack_public_path__ + "img/icon-next.b02d406c.svg";